let SubjectProfile = function (props) {
  let { subject, fields } = props;

  let data = {
    "subject_id": subject.displayName,
    "created":    mc.format.date(subject.createdTs),
    "timezone":   subject.timezone,
    "gender":     subject.gender && tx("gender." + subject.gender),
    "age":        subject.age,
    "weight":     subject.weight && mc.format.weight(subject.weight),
    "height":     subject.height && mc.format.height(subject.height)
  };

  let rows = Object.keys(data).map(function (key) {
    return (
      <tr key={key} data-key={key}>
        <th>{tx(key)}</th>
        <td>{subject.id ? (data[key] || "?") : "..."}</td>
      </tr>
    );
  }).concat(fields.map(function (field) {
    let value = "?";
    let found = (subject.metadataFields || []).find(function (f) {
      return f.displayName === field.displayName;
    });

    if (found) {
      value = field.type === "BOOLEAN" ? tx("answer." + found.value) : found.value;
    }

    return (
      <tr key={field.displayName}>
        <th>{field.displayName}</th>
        <td>{value}</td>
      </tr>
    );
  }));

  return (
    <div className="rc-subject-profile">
      <table className="mc-props">
        <tbody>
          {rows}
        </tbody>
      </table>
    </div>
  );
};

module.exports = SubjectProfile;
